// extracted by mini-css-extract-plugin
export default {"post-modal":"styles_post-modal__4AYrL","detail-link":"styles_detail-link__ABjs1"};